import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class FunctionService {
  constructor(
    private router: Router,
  ){}

  urlRegex(): any{
    return /^(?:https?:\/\/)?(?:[\w-]+\.)+[\w-]+(?:\/[\w\-._~:/?#[\]@!$&'()*+,;=%]*)?$/;
  }
  phoneRegex(): any{
    return /[- +()0-9]{10,16}/;
  }
  emailRegex(): any{
    return /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/
  }

  
  safeJsonObject(data: any): any{
    let parsed = {};
    try {
      parsed = JSON.parse(data);
    }
    catch (e) {
      parsed = {};
    }
    return parsed;
  }
  safeJsonArray(data: any): any{
    let parsed = [];
    try {
      parsed = JSON.parse(data);
    }
    catch (e) {
      parsed = [];
    }
    return parsed;
  }
  /** GetProjectById ke `permissionOfLoggedInUser` me "Control Project Details" ho to user project edit kar sakta hai. */
  canControlProjectDetails(permissionOfLoggedInUser: any): boolean {
    // ContactPermissions option set: 8 = View Project Details, 9 = Control Project Details.
    // Id bhi dekhte hain kyunki `language: ar` par title translate ho kar aa sakta hai.
    return (permissionOfLoggedInUser?.permissions ?? []).some(
      (p: any) => Number(p?.permissionId) === 9 || (p?.permissionTitle || '').toLowerCase() === 'control project details'
    );
  }
  getCurrentUrlNoParams(): string {
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    urlTree.fragment = null;
    return urlTree.toString();
  }
  removeParamsFromURL(url: any): string {
    let urlTree = this.router.parseUrl(url);
    urlTree.queryParams = {};
    urlTree.fragment = null;
    return urlTree.toString();
  }
  dateOnlyToServerUTC(d:any): string{
    return moment(d).locale('en').format('YYYY-MM-DD');
  }
  dateToServerUTC(d:any): string{
    return moment(d).utc().locale('en').format();
  }
  dateToServerUTCMidnight(d: any): string {
    return moment.utc(moment(d).format('YYYY-MM-DD')).format('YYYY-MM-DDT00:00:00.000[Z]');
  }
  unixDateToServerUTC(d:any): string{
    return moment.unix(d).utc().locale('en').format();
  }
  dateInLocalFormat(d: any): string {
    return d ? moment.utc(d).local().format('DD MMM YYYY') : '';
  }
  dateTimeInLocalFormat(d: any): string {
    return d ? moment.utc(d).local().format('DD MMM YYYY LT') : '';
  }
  timeInLocalFormat(d: any): string {
    return d ? moment.utc(d).local().format('LT') : '';
  }
  currentDateServerSubmission(): string {
    return moment().utc().locale('en').format();
  }
  serverDataAfterMonth(): string {
    return moment().add(1, 'year').utc().locale('en').format();
  }
  emptyValueValidator(): ValidatorFn  {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
      const value = control.value ? control.value.replace(/\s/g, '') : '';
      return value.length > 0 ? null : { empty: true };
    };
  }
  truncateToDecimalPlaces(num: any, decimalPlaces: any = 2): any {
    const factor = Math.pow(10, decimalPlaces);
    return Math.floor(num * factor) / factor;
  }
  getRequirementStatus(r:any): string{
    return r.isClosed ? 'Completed' : (r.isCancelled ? 'Cancelled' : (r.state === 2 ? 'In Progress' : 'Open'));
  }
  deepGet (obj: any, props: any, defaultValue: any) {
    // If we have reached an undefined/null property
    // then stop executing and return the default value.
    // If no default was provided it will be undefined.
    if (obj === undefined || obj === null) {
      return defaultValue;
    }
    // If the path array has no more elements, we've reached
    // the intended property and return its value
    if (props.length === 0) {
      return obj;
    }
    // Prepare our found property and path array for recursion
    var foundSoFar = obj[props[0]];
    var remainingProps = props.slice(1);
    return this.deepGet(foundSoFar, remainingProps, defaultValue);
  }
  
  isValidJSON(data: string): boolean {
    try {
      JSON.parse(data);
      return true;
    } catch {
      return false;
    }
  }
  returnJSONForSubmit(data: any): any {
    const emailList = [];
    if(typeof data === 'string' && this.isValidJSON(data)){
      const parsedData = JSON.parse(data);
      if(parsedData != null){
        parsedData.forEach(item => {
          if(item.contact){
            emailList.push({
              contactId: item.contact?.id ?? null,
              email: item.contact?.email ?? null
            });
          }
        });
      }
    }
    return emailList;
  }
  saveFile = (blob: Blob, filename: string) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 500);
  }
  createEncodedURL(baseURL: string, params: any) {
    const encodedParams = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
      .join('&');

    return `${baseURL}?${encodedParams}`;
  }
  checkIfCurrentUserInResponsible(contacts: any, responsible: any, userId: any): boolean{
    if(responsible && contacts && contacts.length > 0){
      const responsibleContacts = contacts.filter((contact: any) => responsible.some((item: any) => item.contactId == contact.partyContactId));
      return responsibleContacts.some((item: any) => item.ownerId == userId);
    }
    return false;
  }
}
